import { DataRecord, ParsedDataRecord } from '@/types/DataRecord';

export const DataRecordTools = {
  parse: ({ src, referenced }: DataRecord): ParsedDataRecord => ({
    referenced: new Date(referenced),
    src: new URL(src),
  }),
};
